import { theme as pdcTheme, overrideComponents, PDCCreateTheme } from "@mzc-pdc/ui";
import { alpha } from "@mui/material";

const projectPalette = {
    light: {
        text: {
            primary: "#3c3d4f",
            secondary: "#6f6f83",
            disabled: "#B1B5BA",
        },
        constant: {
            black: "#000000",
            white: "#FFFFFF",
        },
    },
    dark: {
        background: {
            default: "#2B2B31",
            paper: "#2B2B31",
        },
        common: {
            black: "#FFFFFF",
            white: "#2B2B31",
        },
        constant: {
            black: "#000000",
            white: "#FFFFFF",
        },
        primary: {
            A700: "#2E2E31",
            A400: "#87878F",
            A200: "#BEC0C9",
            A100: "#D1D2D9",
            900: "#F6F7FF",
            800: "#EFF0FF",
            700: "#E7E9FF",
            600: "#C2C8FE",
            500: "#96A4FE",
            400: "#6280FF",
            300: "#2763EA",
            200: "#1352FF",
            100: "#003BF0",
            50: "#0022D9",
            main: "#6280FF",
            light: "#2763EA",
            dark: "#F6F7FF",
            contrastText: "#ffffff",
        },
        secondary: {
            900: "#BDC2D4",
            800: "#939BB7",
            700: "#6B769A",
            600: "#4D5A87",
            500: "#4A5E9F",
            400: "#2A396D",
            300: "#1B2856",
            200: "#11193F",
            100: "#04060F",
            50: "#03040A",
            main: "#6B769A",
            light: "#4A5E9F",
            dark: "#BDC2D4",
            contrastText: "#ffffff",
        },
        success: {
            900: "#59B445",
            800: "#39A71C",
            700: "#2F9812",
            600: "#218701",
            500: "#0F7600",
            400: "#0E6F00",
            300: "#0D6700",
            200: "#0C5E01",
            100: "#0A5600",
            50: "#094D00",
            main: "#2F9812",
            light: "#0F7600",
            dark: "#59B445",
            contrastText: "#ffffff",
        },
        info: {
            900: "#0783FF",
            800: "#1670EB",
            700: "#1C5DD8",
            600: "#213DB9",
            500: "#1532AD",
            400: "#1430A4",
            300: "#132E9C",
            200: "#122B93",
            100: "#112889",
            50: "#10247C",
            main: "#1C5DD8",
            light: "#1532AD",
            dark: "#0783FF",
            contrastText: "#ffffff",
        },
        warning: {
            900: "#FFA927",
            800: "#FB8F01",
            700: "#F57F00",
            600: "#EF6F00",
            500: "#E65400",
            400: "#DB5001",
            300: "#D14D01",
            200: "#C54800",
            100: "#B64301",
            50: "#AD4001",
            main: "#F57F00",
            light: "#E65400",
            dark: "#FFA927",
            contrastText: "#ffffff",
        },
        error: {
            900: "#FF4F20",
            800: "#FD491B",
            700: "#EF4016",
            600: "#E13A11",
            500: "#C82B06",
            400: "#BE2805",
            300: "#B32605",
            200: "#A72405",
            100: "#9D2104",
            50: "#8F1D02",
            main: "#EF4016",
            light: "#C82B06",
            dark: "#FF4F20",
            contrastText: "#ffffff",
        },
        grey: {
            900: "#D5D5D5",
            800: "#B0B0B0",
            700: "#999999",
            600: "#686868",
            500: "#555555",
            400: "#373737",
            300: "#171717",
            200: "#131313",
            100: "#101010",
            50: "#0B0B0B",
            main: "#686868",
            light: "#131313",
            dark: "#D5D5D5",
            contrastText: "#000000",
        },
        greySecondary: {
            A700: "#C9D4F4",
            A400: "#7085D0",
            A200: "#5174F4",
            A100: "#2F3E72",
            900: "#E7E7F2",
            800: "#DFDFEE",
            700: "#D0D0DF",
            600: "#B6B6CA",
            500: "#9898AD",
            400: "#83839A",
            300: "#6F6F83",
            200: "#5B5B6F",
            100: "#3C3D4F",
            50: "#353647",
            main: "#DFDFEE",
            light: "#6F6F83",
            dark: "#E7E7F2",
            contrastText: "#2B2B31",
        },
        text: {
            primary: "#DFDFEE",
            secondary: "#B6B6CA",
            disabled: "#B1B5BA",
        },
        divider: "#3C3D4F",
        action: {
            active: "rgba(255, 255, 255, 0.54)",
            hover: "rgba(255, 255, 255, 0.04)",
            hoverOpacity: 0.04,
            selected: "rgba(255, 255, 255, 0.08)",
            selectedOpacity: 0.08,
            disabled: "rgba(255, 255, 255, 0.3)",
            disabledBackground: "rgba(255, 255, 255, 0.12)",
            disabledOpacity: 0.38,
            focus: "rgba(255, 255, 255, 0.12)",
            focusOpacity: 0.12,
            activatedOpacity: 0.12,
        },
    },
};
export const projectTheme = {
    ...pdcTheme,
    palette: {
        ...pdcTheme?.palette,
        ...(window.location.pathname.indexOf("/library/") === 0 ? projectPalette.dark : projectPalette.light), //Palette mode가 dark인지 light인지에 따라 색상을 다르게 설정
        mode: window.location.pathname.indexOf("/library/") === 0 ? "dark" : "light",
        etc: {
            purple400: "#8660D9",
            purple500: `#5F62E5`,
            purple600: "#7047F3",
            red500: "#EF4B4B",
            blue400: "#5D8FFF",
            blue500: "#405FFF",
            gray300: "#7182A6",
            gray500: "#3F485A",
            pink300: "#FF92AE",
            pink500: "#E86894",
            pink700: "#EE266B",
            orange500: "#FFAA31",
            orange700: "#E07F2D",
            mint300: "#16E1B4",
            mint500: "#009EA0",
            mint700: "#3F585A",
            green500: "#65A93B",
            green600: "#397A11",
            yellow500: "#F2DB0F",
            googleCloudCdnLight: "#FEBA02",
        },
    },
    typography: {
        ...pdcTheme.typography,
    },
    mixins: {
        toolbar: {
            minHeight: `56px`,
            "@media (min-width: 600px)": {
                minHeight: "56px",
            },
        },
    },
    breakpoints: {
        ...pdcTheme.breakpoints,
        values: {
            ...pdcTheme.breakpoints.values,
            xxxl: 1650,
        },
    },
    zIndex: {
        appBar: 500,
        drawer: 500,
        modal: 900,
    },
    // spacing: (factor) => `${factor*0.5}rem`
};

/**
 * 콘솔 스크롤바 전역 기준 (DAM-471).
 *
 * 이 파일이 유일한 출처다. 예전에는 styles/theme.js 와 styles/global.js 두 곳이
 * 서로 다른 값(thumb 색 alpha(greySecondary.main,0.16) vs #dce1e5)으로 같은 셀렉터를
 * 덮어쓰고 있었고, global.js 는 `!isCms` 일 때만 붙어서 CMS 화면과 그 밖의 화면의
 * 스크롤바 색이 달랐다. global.js 쪽 블록은 제거했다.
 *
 * 두께: webkit 트랙 8px. ⚠️ 다만 **현행 브라우저에서 실제로 적용되는 값은 아니다** —
 *       아래 scrollbarWidth: "thin" 이 지정된 요소에서는 Chrome 121+ 가 ::-webkit-scrollbar
 *       규칙을 전부 무시한다(실측: webkit 을 8px 로 두든 20px 로 두든 점유 폭 11px).
 *       즉 Chrome/Firefox/Safari 에서는 `thin`(Chrome 11px), 8px 는 Chrome 109~120 폴백이다.
 *       border-radius 와 transition 페이드도 같은 이유로 현행 브라우저에는 적용되지 않는다.
 *       이전 값은 14px 트랙 + 4px 투명 테두리(= 보이는 thumb 6px)였으므로 어느 쪽이든 좁아졌다.
 * 색:   alpha(greySecondary.main, 0.32). 토큰(greySecondary[300]) 대신 alpha 를 쓰는 건
 *       팔레트가 light/dark 로 뒤집히기 때문이다 — main 은 두 모드에서 각각 전경색이라
 *       alpha 를 씌우면 배경 대비가 알아서 맞는다. 고정 토큰은 한쪽 모드에서 뒤집힌다.
 * 노출: 평소 alpha 0.2 로 아주 옅게, 영역에 마우스가 있을 때 0.32 로 진해진다.
 *       완전히 숨겼다가 되돌린 값이다 — 「스크롤되는 줄 몰랐다」를 막으려면 흔적이 필요하고,
 *       gutter 로 폭이 이미 고정돼 있어 흔적이 있어도 레이아웃은 안 흔들린다.
 *       ⚠️ LNB(nav.styled.js)는 예외로 평소 완전 투명이다 — FE 가 의도적으로 hover-only 로
 *       만들어 둔 곳이라(base 의 overflowY: hidden → hover 시 overlay) 그 결정을 유지한다.
 *
 * ⚠️ scrollbar-gutter 는 여기서 주지 않는다. gutter 는 `overflow: hidden` 인 요소에도
 *    적용돼서(스펙상 hidden 도 scroll container 다) `div` 전역에 걸면 스크롤과 무관한
 *    레이아웃까지 8px 씩 밀린다. 실제 스크롤 영역에만 개별로 준다 — 공용 컴포넌트
 *    목록은 docs/design-handoff/DAM-471-design/README.md 참고.
 */
const SCROLLBAR_SIZE = 8;
const SCROLLBAR_TARGETS = ["main", "div", "ul", "textarea"];
const scrollbarSelector = (suffix) => SCROLLBAR_TARGETS.map((tag) => `${tag}${suffix}`).join(", ");

export const scrollbarStyles = (theme) => {
    const thumbColor = alpha(theme.palette.greySecondary.main, 0.32);
    // 평소에도 아주 옅게 남긴다 — 완전히 숨기면 「스크롤되는 줄 몰랐다」가 된다.
    // gutter 로 폭은 이미 고정돼 있어 흔적이 있어도 레이아웃은 안 흔들린다.
    const idleColor = alpha(theme.palette.greySecondary.main, 0.2);

    return {
        // 표준 속성 — Firefox 전용이 아니다. Chrome · Edge 121+ · Safari 26.2+ 도 지원하고,
        // 지원하는 브라우저에서는 이 두 줄이 같은 요소의 ::-webkit-scrollbar 를 전부 끈다.
        // 즉 아래 webkit 블록은 그보다 낮은 버전의 폴백이고, 현행 브라우저의 실제 렌더는 여기서 결정된다.
        // 한계: 폭은 thin/auto 두 값뿐이라 8px 를 못 맞추고(→ thin), scrollbar-color 는
        // transition 이 안 먹어서 페이드 없이 즉시 바뀐다. 노출 규칙만 같게 맞춘다.
        // 두 블록을 다 남기는 이유는 browserslist 에 Chrome 109~120 과 Safari 18.5~18.7 이
        // 남아 있어서다. 그 환경에서는 폭이 thin 이 아니라 아래 8px 이 된다.
        [scrollbarSelector("")]: {
            scrollbarWidth: "thin",
            scrollbarColor: `${idleColor} transparent`,
        },
        [scrollbarSelector(":hover")]: {
            scrollbarColor: `${thumbColor} transparent`,
        },
        [scrollbarSelector("::-webkit-scrollbar")]: {
            width: SCROLLBAR_SIZE,
            height: SCROLLBAR_SIZE,
        },
        [scrollbarSelector("::-webkit-scrollbar-corner")]: {
            backgroundColor: "transparent",
        },
        [scrollbarSelector("::-webkit-scrollbar-track")]: {
            background: "transparent",
        },
        [scrollbarSelector("::-webkit-scrollbar-thumb")]: {
            backgroundColor: idleColor,
            borderRadius: SCROLLBAR_SIZE / 2,
            transition: "background-color 0.2s",
        },
        [scrollbarSelector(":hover::-webkit-scrollbar-thumb")]: {
            backgroundColor: thumbColor,
        },
    };
};

/**
 * 레거시 화면 전용 오버라이드 (DAM-471).
 *
 * `public/css/cloudplex.core.css` 가 `.modal-body` `.tree-view` `.box-scroll` 같은
 * **클래스** 셀렉터로 스크롤바를 따로 지정해 둔다(14px · rgba(17,25,63,.15) · 상시 노출).
 * 위 전역 규칙은 엘리먼트 셀렉터(div/ul/main/textarea)라 특이도에서 클래스에 진다
 * — 우리 스타일이 문서상 더 뒤에 와도 소용없다. 그래서 그 클래스를 단 요소에만 이걸 얹는다.
 *
 * ⚠️ 실측 정정: 현행 브라우저에서는 위 scrollbarWidth 가 레거시의 ::-webkit-scrollbar 까지
 *    함께 꺼버리므로 아래 !important 블록은 사실상 동작하지 않는다(Chrome 109~120·구형 Safari
 *    폴백으로만 의미가 있다). 실제로 값을 내는 건 scrollbarWidth/scrollbarColor 두 줄이다.
 *
 * ⚠️ 근본 해결은 이 파일이 아니라 public/css 쪽이다. 그 CSS 는 이 저장소에 커밋돼 있지만
 *    SCSS 원본은 여기 없는 **컴파일 산출물**이라, 산출물만 고치면 다음 재빌드에 되돌아간다.
 *    원본 위치 확인이 먼저다 — 후속 티켓으로 분리한다.
 *    적용 대상 클래스 전체 목록은 docs/design-handoff/DAM-471-design/README.md §2.1 참고.
 */
export const legacyScrollbarSx = (theme) => {
    const thumbColor = alpha(theme.palette.greySecondary.main, 0.32);
    const idleColor = alpha(theme.palette.greySecondary.main, 0.2);

    return {
        scrollbarWidth: "thin",
        scrollbarColor: `${idleColor} transparent`,
        "&:hover": { scrollbarColor: `${thumbColor} transparent` },
        "&::-webkit-scrollbar": {
            width: `${SCROLLBAR_SIZE}px !important`,
            height: `${SCROLLBAR_SIZE}px !important`,
        },
        "&::-webkit-scrollbar-track": { background: "transparent !important" },
        "&::-webkit-scrollbar-thumb": {
            background: `${idleColor} !important`,
            borderRadius: `${SCROLLBAR_SIZE / 2}px !important`,
            border: "0 !important",
            transition: "background-color 0.2s",
        },
        "&:hover::-webkit-scrollbar-thumb": {
            background: `${thumbColor} !important`,
        },
    };
};

/**
 * 스크롤바 자리(gutter)의 예약 폭. DAM-646 에서 `layout.styled.js` 가 처음 쓴 값을 여기로 올렸다.
 *
 * 예약 폭은 OS·브라우저·배율마다 다르므로 상수로 박지 않고 CSS 변수 한 곳에서 관리한다.
 * ⚠️ 지금 이 변수를 `set` 하는 코드는 없다 — fallback `11px` 로만 동작한다(macOS 클래식 스크롤바 실측값).
 *    Windows 등에서 여백이 어색하다는 QA 가 들어오면 그때 이 변수를 주입하면 전부 따라 움직인다.
 */
export const SCROLLBAR_GUTTER_WIDTH = `var(--cpm-scrollbar-gutter, 11px)`;

export const projectOverrideTheme = {
    ...projectTheme,
    components: {
        ...overrideComponents(projectTheme),
        // 입력 하단 안내/에러 문구는 디자인 가이드라인 기준 12px, 필드 좌측선에 맞춰 정렬.
        // pdc-ui·프로젝트 테마 어디에도 override 가 없어 MUI 기본값으로 렌더되고 있었다:
        //  - 크기 14px (MUI 기본은 typography.caption 인데 실제로는 0.875rem 로 적용됨)
        //  - variant 가 outlined/filled 일 때 `MuiFormHelperText-contained` 가 margin: 0 14px 을 걸어
        //    문구가 입력 필드보다 14px 안쪽으로 들어가 정렬이 어긋나 보임
        // (Figma: SPACE DAM CDN Design Guideline v1.0)
        MuiFormHelperText: {
            styleOverrides: {
                root: ({ theme }) => ({
                    fontSize: theme.typography.body3.fontSize,
                }),
                contained: {
                    marginLeft: 0,
                    marginRight: 0,
                },
            },
        },
        MuiCssBaseline: {
            styleOverrides: (theme) => ({
                body: {
                    transition: "background-color 0.3s ease",
                    backgroundColor: theme.palette.common.white,
                    color: theme.palette.greySecondary.main,
                },
                html: {
                    overflow: "hidden",
                    fontSize: "16px",
                    height: "100%",
                },
                "#root": {
                    height: "100%",
                },
                ".container": {
                    height: "100%",
                },
                a: {
                    color: "inherit",
                    textDecoration: "none",
                    "&:focus": {
                        outline: 0,
                    },
                    "&:hover, &:active": {
                        outline: 0,
                    },
                },
                ...scrollbarStyles(theme),
                // 레거시 CSS 툴팁을 MUI 툴팁과 같은 모양으로 맞춘다 (DAM-655).
                // cloudplex.core.css 는 컴파일 산출물이라 직접 못 고치고(designer.md §4),
                // 그 파일을 관리하던 쪽이 더는 수정하지 않아 여기서 덮어쓴다.
                // ⚠️ global.js 가 아니라 여기다 — global.js 는 App.js 에서 isCms 일 때 안 붙어
                //    CMS 화면만 옛 스타일로 남는다(DAM-471 이 스크롤바에서 겪고 옮긴 이유와 같다).
                "[data-tooltip]:after": {
                    // pdc-ui 가 MUI 툴팁 캐럿에 쓰는 것과 같은 토큰 — 툴팁 색이 바뀌면 같이 따라간다.
                    // ⚠️ 활성 테마(light)의 greySecondary 는 pdc 기본값이라 프로젝트 dark 팔레트와 스케일이 반대다.
                    //    [300] 은 #B6B6CA 로 풀려 대비 1.99:1 이 됐다 — 토큰은 실측으로 확인한다.
                    backgroundColor: theme.palette.greySecondary[600],
                    // 🔴 색은 배경만 맞추면 안 된다 — core.css 가 color: #fff 를 박아둬서
                    //    다크 팔레트(/library/ = CMS)에서 greySecondary[600] 이 #B6B6CA 로 풀리면
                    //    흰 글자 대비가 1.99:1 로 원래(3.38)보다 나빠진다. MUI 툴팁은 모드마다
                    //    글자색을 바꿔 통과하므로 같은 토큰(contrastText)을 따라간다.
                    color: theme.palette.greySecondary.contrastText,
                    fontSize: "11px",
                    lineHeight: 1.5,
                    padding: "4px 8px",
                    borderRadius: "3px",
                },
                // .sprite-info 는 자기 배경(#11193f)을 특이도로 지키므로 글자색도 따로 준다.
                // 위 base 의 contrastText 를 그대로 받으면 다크 모드에서 어두운 글자 + 어두운 배경이 되어 1.21:1 이 된다.
                // 같은 셀렉터로 맞춰야 이긴다(0,2,1) — emotion 이 뒤에 와서 동률이면 이긴다.
                ".sprite-info[data-tooltip]:after": {
                    // ⚠️ 토큰이 아니라 리터럴이다. 이 배경(#11193f)은 core.css 에 하드코딩돼 있어
                    //    모드가 바뀌어도 안 변한다 — 글자색만 모드를 따라가면 다크에서 1.21:1 이 된다.
                    //    실측: theme.palette.common.white 는 다크에서 #2B2B31 로 풀린다(반전됨).
                    color: "#fff",
                },
                // 캐럿을 쓰지 않는다 — DAM-653 이 MUI 툴팁에서 막은 것과 같은 규칙.
                // .tooltip-failover 는 JSX 사용처가 없지만 core.css 에서 같은 블록을 공유한다.
                ".tooltip-failover .tooltip:before, .tooltip-repeat .tooltip:before": {
                    content: "none",
                },
                ".MuiList-root:has(.MuiDivider-root)::-webkit-scrollbar-track": {
                    borderLeft: "1px solid #dfdfee",
                },
                '.MuiButtonBase-root[aria-expanded="true"]': {
                    backgroundColor: `rgba(0, 0, 0, 0.04)`,
                },
                ".MuiInputBase-root .MuiInputBase-input::-webkit-input-placeholder": {
                    opacity: 1,
                    color: theme.palette.greySecondary[400],
                },
                button: {
                    margin: 0,
                    padding: 0,
                    border: "none",
                    backgroundColor: "transparent",
                },
                address: {
                    fontStyle: "normal",
                },
                ".modal-footer button": {
                    marginLeft: "6px",
                },
                ".MuiPickersDay-root, .MuiPickersYear-yearButton": {
                    "&.Mui-selected:hover": {
                        backgroundColor: `${theme.palette.primary.main} !important`,
                    },
                    "&:hover": {
                        backgroundColor: alpha(theme.palette.primary.main, 0.08),
                    },
                    "&:focus": {
                        backgroundColor: alpha(theme.palette.primary.main, 0.12),
                        "&.Mui-selected": {
                            backgroundColor: `${theme.palette.primary.main} !important`,
                        },
                    },
                    "&:disabled": {
                        color: theme.palette.greySecondary.main,
                    },
                    "&.MuiPickersDay-today": {
                        "&:hover": {
                            backgroundColor: alpha(theme.palette.greySecondary.main, 0.08),
                        },
                        "&:focus": {
                            backgroundColor: alpha(theme.palette.greySecondary.main, 0.12),
                        },
                    },
                },
                ".MuiPaper-root": {
                    backgroundImage: "none !important",
                },
                ".MuiModal-root input[type='text']:not([class*='MuiInputBase-input'])": {
                    backgroundColor: theme.palette.background.default,
                    border: `1px solid ${theme.palette.greySecondary.light}`,
                    borderRadius: theme.spacing(0.25),
                    color: theme.palette.greySecondary.main,
                    "&:hover": {
                        border: `1px solid ${theme.palette.primary.main}`,
                    },
                },
                ".DateRangePickerInput": {
                    backgroundColor: theme.palette.background.default,
                    border: `1px solid ${theme.palette.greySecondary.light} !important`,
                    "& div": {
                        backgroundColor: theme.palette.background.default,
                    },
                    "& div.DateRangePickerInput_arrow::after": {
                        backgroundColor: theme.palette.background.default,
                    },
                },
                // 구형 공용 필터바의 날짜 입력 폭은 cloudplex.core.css의 전역
                // `.DateInput__small { width: 85px !important }`가 결정한다. 85px로는
                // 포르투갈어 "Data de término"이 "Data de térmi"로 잘리므로 폭을 넓힌다.
                // core.css는 타부서 관리 파일이라 여기서 오버라이드한다. (DAM-387)
                //
                // 전역 `.DateInput__small`을 그대로 덮으면 앱 전체 날짜 입력(87곳)이 모든
                // 언어에서 넓어지므로, 잘림이 실제로 발생하는 두 계열만 지정한다.
                //
                // width 가 아니라 min-width 로 지정한다. `.DateInput__small` 에는 min-width
                // 선언이 core.css 어디에도 없어 !important 없이 width 를 이기고, 좁은
                // 화면(≤768px)의 `width: 37% !important` 규칙과도 공존한다 — 37%가 124px보다
                // 넓으면 기존 비율이 그대로 유지되고, 좁아지면 124px에서 멈춰 잘리지 않는다.
                // (width로 덮으면 특이도가 동률이라 주입 순서에 의존하는 데다, 좁은 화면의
                // 반응형 비율까지 잃는다.)
                //
                // 구형 공용 필터바 (Job·Search·Archived assets·Admin 목록 등 13개 화면)
                ".form-search .area-search .DateInput__small": {
                    minWidth: "124px",
                },
                // 신형 고급검색 팝오버 (MUI Popover로 포털되어 위 셀렉터에 안 걸림)
                ".MuiPopover-root .DateInput__small": {
                    minWidth: "124px",
                },
                // 다운로드 링크 모달의 다운로드 횟수·메일 언어 셀렉터는 core.css가 컨테이너 폭을
                // 90px로 고정해 둔다. 컨트롤의 minWidth(120px)보다 좁아 컨트롤이 컨테이너를 넘치고,
                // sm 패딩(23px)과 인디케이터를 빼면 문구 영역이 ~42px뿐이라 "English"조차 잘린다.
                // 컴팩트(sm) 셀렉터의 기본 동작인 width: auto로 되돌려 내용에 맞게 잡히게 한다.
                // flex: none·margin은 core.css 값을 그대로 둔다. (DAM-387)
                ".modal-download-link .link-setting > div > span .select2-container": {
                    width: "auto",
                },
                ".select2-selection__control": {
                    backgroundColor: `${theme.palette.background.default} !important`,
                    border: `1px solid ${theme.palette.greySecondary.light} !important`,
                    borderRadius: theme.spacing(0.25),
                },
                ".category-select .category-group": {
                    border: `1px solid ${theme.palette.greySecondary.light} !important`,
                },
                ".tags-inputs .tags": {
                    backgroundColor: theme.palette.background.default,
                    border: `1px solid ${theme.palette.greySecondary.light} !important`,
                    borderRadius: theme.spacing(0.25),
                    "& textarea": {
                        color: theme.palette.greySecondary.main,
                    },
                },
                ".MuiTable-root": {
                    "& th": {
                        boxShadow: "none !important",
                    },
                },
                ".MuiTextField-root .MuiOutlinedInput-root": {
                    backgroundColor: theme.palette.background.default,
                    "& .Mui-disabled": {
                        backgroundColor: theme.palette.background.default,
                    },
                },
                "textarea.MuiInputBase-inputMultiline": {
                    minHeight: "unset",
                },
                ".MuiBackdrop-root:not(.MuiBackdrop-invisible)": {
                    backgroundColor: `${alpha(theme.palette.constant.black, 0.3)} !important`,
                },
                "input[type='text']:-webkit-autofill, input[type='text']:-webkit-autofill:hover, input[type='text']:-webkit-autofill:focus, input[type='text']:-webkit-autofill:active, input[type='password']:-webkit-autofill, input[type='password']:-webkit-autofill:hover, input[type='password']:-webkit-autofill:focus, input[type='password']:-webkit-autofill:active, input[type='number']:-webkit-autofill, input[type='number']:-webkit-autofill:hover, input[type='number']:-webkit-autofill:focus, input[type='number']:-webkit-autofill:active, input[type='tel']:-webkit-autofill, input[type='tel']:-webkit-autofill:hover, input[type='tel']:-webkit-autofill:focus, input[type='tel']:-webkit-autofill:active, input[type='url']:-webkit-autofill, input[type='url']:-webkit-autofill:hover, input[type='url']:-webkit-autofill:focus, input[type='url']:-webkit-autofill:active, input[type='email']:-webkit-autofill, input[type='email']:-webkit-autofill:hover, input[type='email']:-webkit-autofill:focus, input[type='email']:-webkit-autofill:active":
                    {
                        WebkitBoxShadow: `0 0 0 30px ${theme.palette.background.default} inset !important`,
                        WebkitTextFillColor: theme.palette.greySecondary.main,
                    },
            }),
        },
        MuiTooltip: {
            styleOverrides: {
                // 앵커와의 간격은 모든 placement 에서 4px 로 둔다.
                // marginTop 만 두면 bottom 계열에만 걸리고 top·right·left 는 MUI 기본 14px 로 남는다.
                // ⚠️ 이 값을 바꾸면 popper offset 을 손으로 맞춰 둔 호출부의 실효 간격이 같이 움직인다.
                //    바꾸기 전에 `grep -rn -A8 '<Tooltip' | grep -E 'offset|PopperProps|slotProps'` 를 돌린다.
                tooltip: {
                    margin: "4px !important",
                },
                // 툴팁에 캐럿을 쓰지 않는다. 호출부가 arrow 를 넘겨도 이 규칙이 이긴다
                // (defaultProps 로는 못 막는다 — 명시 prop 이 defaultProps 를 덮는다).
                // 정말 캐럿이 필요한 화면이 생기면 여기를 고치지 말고 그 호출부에서 뚫는다:
                //   slotProps={{ tooltip: { sx: { "& .MuiTooltip-arrow": { display: "block" } } } }}
                arrow: {
                    display: "none",
                },
            },
        },
        MuiTableRow: {
            styleOverrides: {
                root: ({ theme }) => ({
                    th: {
                        backgroundColor: theme.palette.common.white,
                        color: theme.palette.greySecondary.main,
                        boxShadow: "none",
                    },
                }),
            },
        },
        MuiSwitch: {
            styleOverrides: {
                root: ({ ownerState, theme }) => ({
                    width: 52,
                    height: 34,
                    ".MuiSwitch-thumb": {
                        backgroundColor:
                            ownerState.checked === true
                                ? theme.palette[ownerState.color ? ownerState.color : "success"].main
                                : theme.palette.greySecondary[300],
                    },
                    ".Mui-checked": {
                        ".MuiSwitch-thumb": {
                            backgroundColor: theme.palette[ownerState.color ? ownerState.color : "success"].main,
                        },
                        "&.Mui-disabled": {
                            ".MuiSwitch-thumb": {
                                boxShadow: "none",
                                backgroundColor: theme.palette.success[100],
                            },
                            "+ .MuiSwitch-track": {
                                backgroundColor: theme.palette.success[50],
                            },
                        },
                    },
                    ".Mui-disabled": {
                        ".MuiSwitch-thumb": {
                            boxShadow: "none",
                            backgroundColor: theme.palette.greySecondary[200],
                        },
                        "+ .MuiSwitch-track": {
                            opacity: "1 !important",
                            backgroundColor: theme.palette.greySecondary[50],
                        },
                    },
                }),
                switchBase: {
                    left: 3,
                    "&.Mui-checked": {
                        transform: "translateX(12px)",
                    },
                },
                thumb: {
                    width: 16,
                    height: 16,
                },
                track: ({ theme }) => ({
                    opacity: 1,
                    backgroundColor: theme.palette.greySecondary[100],
                }),
            },
        },
        MuiButton: {
            styleOverrides: {
                // 기존 스타일 덮어쓰지 않도록 먼저 가져오기
                ...overrideComponents(projectTheme).MuiButton?.styleOverrides,

                sizeXsmall: ({ theme }) => ({
                    padding: theme.spacing(0, 1),
                    height: 24,
                    fontSize: theme.typography["body3"].fontSize,
                    [theme.breakpoints.down("sm")]: {
                        fontSize: `0.688rem`,
                    },
                }),
            },
        },
    },
};

const theme = PDCCreateTheme(projectOverrideTheme);
export default theme;
export const narrowTheme = PDCCreateTheme({ ...projectOverrideTheme, spacing: 7 });
